import { useMemo } from "react";
import { getTenantConfig, TenantConfig } from "./tenantConfig";

/**
 * Hook que devuelve la configuración del tenant actual.
 * Memoizado para no recalcular en cada render.
 */
export const useTenant = (): TenantConfig => useMemo(() => getTenantConfig(), []);

export default useTenant;
